import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CompareImagesComponent} from './compare-images.component';
import {ShowFromExternalApiComponent} from './show-from-external-api/show-from-external-api.component';
import {ShowFromFileComponent} from './show-from-file/show-from-file.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {ImageCropperModule} from 'ngx-image-cropper';
import {DialogEditImageComponent} from './dialog-edit-image/dialog-edit-image.component';
import {LoadingSpinnerModule} from '../loading-spinner/loading-spinner.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    ImageCropperModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    DragDropModule,
    LoadingSpinnerModule
  ],
  declarations: [CompareImagesComponent, ShowFromExternalApiComponent, ShowFromFileComponent, DialogEditImageComponent],
  exports: [CompareImagesComponent]
})

export class CompareImagesModule {}
